module.exports = __webpack_public_path__ + "img/Roza-Mlwanka.601f4f94.jpg";